import { render, staticRenderFns } from "./PlacesOfUsageGroupMapping.vue?vue&type=template&id=4c3ee585&scoped=true&"
import script from "./PlacesOfUsageGroupMapping.vue?vue&type=script&lang=js&"
export * from "./PlacesOfUsageGroupMapping.vue?vue&type=script&lang=js&"
import style0 from "./PlacesOfUsageGroupMapping.vue?vue&type=style&index=0&id=4c3ee585&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3ee585",
  null
  
)

export default component.exports